import { Component, computed, effect, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthStore } from './core/auth/store/auth.store';
import { AuthActionsService } from './core/auth/services/auth-actions.service';
import { DialogService } from './ui/dialog/dialog.service';
import { CambiarPasswordForm } from './modules/admin/usuarios/cambiar-password-form/cambiar-password-form';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, MatProgressBarModule],
  templateUrl: './app.html'
})
export class App {
  private auth = inject(AuthStore);
  private dialog = inject(DialogService);
  private authActions = inject(AuthActionsService);
  protected readonly title = signal('FinanTaxi');

  isLoading = computed(() => this.auth.permissions.isLoading());

  private _listen = effect(() => {
    const trigger = this.authActions.changePasswordTrigger();
    if (trigger > 0) {
      this.openChangePasswordDialog();
    }
  });

  private openChangePasswordDialog() {
    const user = this.auth.user.value();
    if (!user) return;
    this.dialog.openTabbedDialog([{
      name: 'Nueva Contraseña',
      component: CambiarPasswordForm,
      data: { row: { id: user.id, username: user.username } },
      actions: { showSave: true, closeLabel: 'Cancelar' }
    }], { title: `Cambiar contraseña: ${user.username}`, mode: 'bounded', variant: 'compact' });
  }
}
